<template>
  <b-datepicker
    icon="calendar-today"
    :value="selectedDate"
    :max-date="maxDate"
    :min-date="new Date(minDate)"
    @input="onInput"
    :placeholder="placeholder"
  ></b-datepicker>
</template>

<script>
import moment from "moment";

export default {
  props: {
    value: {
      type: String
    },

    placeholder: {
      type: String
    },

    minDate: {
      type: String,
      default: "2018-01-01"
    }
  },

  computed: {
    maxDate() {
      return new Date();
    },

    selectedDate() {
      if (this.value) {
        return new Date(this.value);
      }

      return null;
    }
  },

  methods: {
    onInput(value) {
      let date = moment(value).format("YYYY-MM-DD");

      this.$emit("input", date);
    }
  }
};
</script>
